import { Modal } from "antd";
import ParametrosCobrancaForm from "./ParametrosCobrancaForm";
import { useCurrentTenant } from "features/auth/tenant.store";

interface ModalParametrosCobrancaProps {
  isOpen: boolean;
  onClose: () => any;
}

function ModalParametrosCobranca({
  isOpen,
  onClose,
}: ModalParametrosCobrancaProps) {
  const { tenant } = useCurrentTenant();

  return (
    <Modal
      destroyOnClose
      width="1000px"
      footer={null}
      centered
      bodyStyle={{
        overflow: "auto",
        marginTop: 16,
        marginBottom: 16,
        height: "max(80vh, 400px)",
        padding: 16,
      }}
      visible={isOpen}
      onCancel={onClose}
    >
      <ParametrosCobrancaForm
        tenant={tenant?.id}
        onClose={onClose}
        textSalvar="Salvar"
      />
    </Modal>
  );
}

export default ModalParametrosCobranca;
